import { useEffect } from 'react'
import { useCombinedLogsTableStateStore } from '../store'
import { FilterType } from '@/types/logs'

export const useHandleHotkeys = (setIsCreateFormActive: () => void) => {
    const { setFilter } = useCombinedLogsTableStateStore()

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const target = e.target as HTMLElement
            const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable

            if (isInput) return

            if (e.shiftKey && e.key.toLowerCase() === 'l') {
                e.preventDefault()
                setFilter(FilterType.DailyLog)
                setIsCreateFormActive()
            }

            if (e.shiftKey && e.key.toLowerCase() === 'm') {
                e.preventDefault()
                setFilter(FilterType.MileageLoss)
                setIsCreateFormActive()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [])
}
